<template>
  <div class="iDalgo-Section-Min">
    <h2 class="iDalgo-Section-Min__Title">
      <span class="iDalgo-Section-Min__Title_Number">{{ section.size }}</span>
      <span class="iDalgo-Section-Min__Title_Value">{{ section.name }}</span>
    </h2>
    <div class="iDalgo-Section-Min__Cards">
      <i-dalgo-card-min
        v-for="(player, key) in section._players"
        :key="player.id"
        :picture="player.tUrlPicture"
        :title="player.tNickName"
        :percent="player.percent"
        :disabled="key >= section.size"
        :active="player.active" />
    </div>
  </div>
</template>

<script>
import iDalgoCardMin from '@/components/iDalgo-Card-Min'

export default {
  name: 'iDalgo-Section-Min',
  components: {
    iDalgoCardMin
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.iDalgo-Section-Min {
  display: flex;
  flex-flow: row;

  &__Cards {
    width: calc(100% - 100px);
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  &__Title {
    width: 100px;
    color: #35312E;
    font-family: "source_sans_probold", sans-serif;
    margin: 0;
    margin-top: 24px;

    &_Number {
      display: block;
      width: 30px;
      height: 30px;
      background: $color1_light;
      font-family: "source_sans_proregular", sans-serif;
      border-radius: 25px;
      font-size: 26px;
      text-align: center;
      line-height: 36px;
      color: #fff;
      margin-bottom: 6px;
      box-sizing: border-box;
    }

    &_Value {
      color: $text_gray_light;
      font-family: "source_sans_proregular", sans-serif;
      font-size: 16px;
    }
  }

  @media (max-width: 640px) {
    flex-flow: column;
    &__Cards {
      width: 100%
    }

    &__Title {
      align-items: center;
      width: 100%;
      display: flex;
      flex-flow: row;
      margin-bottom: 16px;

      &_Number {
        margin: 0 10px 6px 0;
      }

      &_Value {
        font-size: 36px;
        opacity: 0.4;
        font-family: "source_sans_prosemibold", sans-serif;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Section-Min.vue